import React from "react";
import Header from "../src/component/header/header";
import Body from "../src/component/body/body";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Body />
    </div>
  );
}

export default App;
